<template>
  <div id="EventAdd">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">活動詳情</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">活動</li>
              <li class="breadcrumb-item">
                <a href="../../event/event.html">活動列表</a>
              </li>
              <li class="breadcrumb-item active">活動詳情</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-8 col-sm-12">
            <div class="card card-secondary">
              <div class="card-body">
                <el-form :model="EventModel" ref="EventModel" :rules="rules">
                  <el-form-item
                    label="活動名稱"
                    label-width="80px"
                    prop="sgL_Title"
                  >
                    <el-input v-model="EventModel.sgL_Title"></el-input>
                  </el-form-item>
                  <el-form-item label="活動類型（可多選）" prop="sgL_TypeIds">
                    <el-checkbox-group v-model="EventModel.sgL_TypeIds">
                      <el-checkbox
                        v-for="item in EventTypeList"
                        :key="item.id"
                        :label="item.id"
                        >{{ item.sgL_NewName }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="活動日期" prop="sgL_ActivityDateA">
                    <el-date-picker
                      v-model="EventModel.sgL_ActivityDateA"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>

                  <el-form-item label="活動地點" prop="sgL_CityId">
                    <div class="row">
                      <div class="col-sm-6">
                        <el-select
                          v-model="EventModel.sgL_CityId"
                          clearable
                          placeholder="请选择地區"
                        >
                          <el-option
                            v-for="Area in EventCityList"
                            :key="Area.id"
                            :label="Area.sgL_NewName"
                            :value="Area.id"
                          ></el-option>
                        </el-select>
                        <el-select
                          v-model="EventModel.sgL_AreaId"
                          clearable
                          placeholder="请选择縣市"
                        >
                          <el-option
                            v-for="Area in EventAreaList"
                            :key="Area.id"
                            :label="Area.sgL_NewName"
                            :value="Area.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-sm-6">
                        <el-input
                          v-model="EventModel.sgL_Address"
                          placeholder="詳細地點"
                        ></el-input>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="報名狀態" prop="sgL_Status">
                    <el-select
                      v-model="EventModel.sgL_Status"
                      clearable
                      placeholder="報名狀態"
                    >
                      <el-option
                        v-for="status in EventStatusList"
                        :key="status.id"
                        :label="status.sgL_NewName"
                        :value="status.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="報名日期">
                    <el-date-picker
                      v-model="EventModel.sgL_ApplyDateA"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>

                  <el-form-item label="主辦單位">
                    <el-input v-model="EventModel.sgL_UnitTitle"></el-input>
                  </el-form-item>
                  <el-form-item label="活動連結" prop="sglActivityUrl">
                    <el-input v-model="EventModel.sglActivityUrl"></el-input>
                  </el-form-item>
                  <el-form-item label="其他連結（如報名連結）">
                    <el-input v-model="EventModel.sglActivityUrl2"></el-input>
                  </el-form-item>
                  <el-form-item label="賽事項目（以 ','作分隔，不需加上空格）">
                    <el-input
                      v-model="EventModel.sgL_KMKeyworld"
                      placeholder="盡量簡短，如3公里組寫3K"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="活動標簽">
                    <el-select
                      v-model="EventModel.sgL_NotesIds"
                      multiple
                      clearable
                      placeholder="请选择標簽"
                    >
                      <el-option
                        v-for="Remark in EventRemarkList"
                        :key="Remark.id"
                        :label="Remark.sgL_NewName"
                        :value="Remark.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="活動内容">
                    <Editor v-model="EventModel.sgL_Content" />
                  </el-form-item>
                  <el-form-item label="關鍵字（以 ',' 作分隔，不需加上空格）">
                    <el-input
                      v-model="EventModel.sgL_KeysWord"
                      placeholder="e.g. 渣打馬拉松,渣打,standard chartered,sc…"
                      type="textarea"
                      :rows="1"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="公開狀態" prop="sgL_OpenStatus">
                    <el-select
                      v-model="EventModel.sgL_OpenStatus"
                      clearable
                      placeholder="公開狀態"
                    >
                      <el-option label="公開" value="Show"></el-option>
                      <el-option label="隱藏" value="None"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      class="float-right"
                      @click="submitForm('EventModel')"
                      >保存</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
            <!-- /.card -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import Editor from "../common/Editor";
import { Message } from "element-ui";
export default {
  data() {
    var CheckCityArea = (rule, value, callback) => {
      // console.log({rule, value});
      if (!value) {
        callback(new Error('請輸入活動地區'));
      } else if (!this.EventModel.sgL_AreaId || this.EventModel.sgL_AreaId == '' || this.EventModel.sgL_AreaId == null) {
        callback(new Error('請輸入活動縣市'));
      }
      else if (!this.EventModel.sgL_Address || this.EventModel.sgL_Address == '' || this.EventModel.sgL_Address == null) {
        callback(new Error('請輸入詳細地址'));
      }
      else {
        callback();
      }
    }
    return {
      EventModel: {
        id: null,
        sgL_Title: null,
        sgL_TypeIds: [],
        sgL_ActivityDateA: [],
        sgL_ApplyDateA: [],
        sgL_Address: null,
        sgL_AreaId: null,
        sgL_CityId: null,
        sgL_KMKeyworld: null,
        sgL_OpenStatus: "Show",
        sgL_Status: null,
        sgL_UnitTitle: null,
        sglActivityUrl: null,
        sglActivityUrl2: null,
        sgL_NotesIds: null,
        sgL_Content: null,
        sgL_KeysWord: null,
      },
      sgL_AreaId:null,
      EventTypeList: null,
      EventCityList: null,
      EventStatusList: null,
      EventAreaList: null,
      EventRemarkList: null,
      rules: {
        // sgL_Content: [
        //   { required: true, message: "請輸入活動内容", trigger: "blur" },
        // ],
        sgL_Title: [
          { required: true, message: "請輸入活動名稱", trigger: "blur" },
        ],
        sgL_Content: [
          { required: true, message: "請輸入活動内容", trigger: "blur" },
        ],
        sglActivityUrl: [
          { required: true, message: "請輸入活動鏈接", trigger: "blur" },
        ],
        sgL_TypeIds: [
          { required: true, message: "請輸入活動類型", trigger: "change" },
        ],
        sgL_CityId: [
          { required: true,validator: CheckCityArea, trigger: "change" },
        ],
        // sgL_AreaId: [
        //   { required: true, message: "請輸入活動城市", trigger: "change" },
        // ],
        sgL_ActivityDateA: [
          { required: true, message: "請輸入活動日期", trigger: "change" },
        ],
        sgL_Status: [
          { required: true, message: "請輸入活動狀態", trigger: "change" },
        ],
        sgL_OpenStatus: [
          { required: true, message: "請輸入公開狀態", trigger: "change" },
        ],
      },
    };
  },
  components: {
    Editor,
  },
  watch: {
    "EventModel.sgL_CityId": {
      immediate: true,
      handler: function (newvalue, oldvalue) {
        if (newvalue != null && newvalue >= 1) {
          this.getEventArea(newvalue);
        }
      },
    },
  },
  created() {
    this.EventModel.id = this.$route.query.Id;
    if (this.EventModel.id != undefined && this.EventModel.id != "") {
      //修改，查询此id的信息
      this.getById(this.EventModel.id);
    }
    this.$store.dispatch("getCommonType", 40).then((res) => {
      this.EventTypeList = res; //活動類型
    });
    this.$store.dispatch("getCommonType", 30).then((res) => {
      this.EventCityList = res; //城市
    });
    this.$store.dispatch("getCommonType", 50).then((res) => {
      this.EventStatusList = res; //活動報名狀態
    });
    this.$store.dispatch("getCommonType", 60).then((res) => {
      this.EventRemarkList = res; //活動附注
    });
  },
  methods: {
    submitForm(formname) {
      // console.log(formname);
      // console.log(this.EventModel.sgL_AreaId);
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let params = {
            sgL_Title: this.EventModel.sgL_Title,
            sgL_TypeIdF: this.EventModel.sgL_TypeIds,
            sgL_ActivityDateF: this.EventModel.sgL_ActivityDateA,
            sgL_ApplyDateF: this.EventModel.sgL_ApplyDateA,
            sgL_Address: this.EventModel.sgL_Address,
            sgL_AreaId: this.EventModel.sgL_AreaId,
            sgL_CityId: this.EventModel.sgL_CityId,
            sgL_KMKeyworld: this.EventModel.sgL_KMKeyworld,
            sgL_OpenStatus: this.EventModel.sgL_OpenStatus,
            sgL_Status: this.EventModel.sgL_Status,
            sgL_UnitTitle: this.EventModel.sgL_UnitTitle,
            sglActivityUrl: this.EventModel.sglActivityUrl,
            sglActivityUrl2: this.EventModel.sglActivityUrl2,
            sgL_NotesIdF: this.EventModel.sgL_NotesIds,
            sgL_Content: this.EventModel.sgL_Content,
            sgL_KeysWord: this.EventModel.sgL_KeysWord,
          };
          if (this.EventModel.id != null) {
            //修改
            params.id = this.EventModel.id;
            this.$api.EventApi.UpdateEvent(params).then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "修改成功",
                });
                this.$router.push({ name: "EventList" });
              } else {
                Message({
                  type: "error",
                  message: "修改失敗",
                });
              }
            });
          } else {
            //添加
            this.$api.EventApi.AddEvent(params).then((result) => {
              if (result.data.success) {
                Message({
                  type: "success",
                  message: "成功",
                });
                this.$router.push({ name: "EventList" });
              } else {
                Message({
                  type: "error",
                  message: "失敗",
                });
              }
            });
          }
        } else {
          Message({
            type: "error",
            message: "請填寫必填數據",
          });
          return false;
        }
      });
    },
    getById(Id) {
      let params = {
        id: Id,
      };
      this.$api.EventApi.GetEvent(params).then((res) => {
        if (res.data.success) {
          this.EventModel = res.data.result;
          this.sgL_AreaId = res.data.result.sgL_AreaId;
        }
      });
    },
    getEventArea(PId) {
      let params = {
        SGL_TypeT: 30, //城市
        MaxResultCount: 100,
        SGL_ParentID: 1, //區域
        SGL_NewTypeId: PId,
      };
      this.$api.EventApi.GetEventType(params).then((res) => {
        if (res.data.success) {
          this.EventModel.sgL_AreaId = this.sgL_AreaId;
          if(this.sgL_AreaId) this.sgL_AreaId = null;
          this.EventAreaList = res.data.result.items;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminEvent/EventAdd.vue